import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {DestinationType} from '../../destinations.types';

@Component({
    selector: 'app-translation-settings',
    standalone: true,
    imports: [CommonModule, FormsModule, MatSlideToggleModule],
    templateUrl: './translation-settings.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslationSettingsComponent {
    @Input() destination: DestinationType;
    @Input() reviewMode: boolean = false;
    @Output() save = new EventEmitter<void>();

    onSave(): void {
        this.save.emit();
    }
}
